import DateTime from "./DateTime";
import DropdownSelect from "./DropdownSelect";
import DateTimePicker from "./DateTimePicker";
import InputCheckBox from "./InputCheckBox";
import MultiCheckBox from "./MultiCheckBox";
import Password from "./Password";
import QRScannerView from "./QRScannerView";
import Radio from "./Radio";
import ScanQRCode from "./ScanQRCode";
import TextArea from "./TextArea";
import TextField from "./TextField";
import TimeSelect from "./TimeSelect";
import Upload from "./Upload";
import UploadApi from "./UploadApi";
import UploadMultiApi from "./UploadMultiApi";

const EXPORT = {
  DateTime,
  DateTimePicker,
  DropdownSelect,
  InputCheckBox,
  MultiCheckBox,
  Password,
  QRScannerView,
  Radio,
  ScanQRCode,
  TextArea,
  TextField,
  TimeSelect,
  Upload,
  UploadApi,
  UploadMultiApi,
};

export default EXPORT;
